module.exports = __webpack_public_path__ + "954983e6dbeccbdc77b6e2c697b2aea8.svg";